import { render, staticRenderFns } from "./_table.vue?vue&type=template&id=5c39adb8&"
import script from "./_table.vue?vue&type=script&lang=js&"
export * from "./_table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports